

























import {Component, Watch, Vue} from 'vue-property-decorator';
import {mapGetters, mapMutations, mapState} from 'vuex';
import PlanEditModel, {Tab} from '@/models/PlanEditModel';
import PlanEditResultSettingsMenu from '@/views/journals/planEdit/planEditTabs/result/PlanEditResultSettingsMenu.vue';
import PlanEditResultEditDialog from '@/views/journals/planEdit/planEditTabs/result/edit/PlanEditResultEditDialog.vue';

@Component({
    components: {PlanEditResultEditDialog, PlanEditResultSettingsMenu},
    computed: {
        ...mapGetters('planEdit', ['hasResult']),
        ...mapState('planEdit', ['planEdit', 'disabledTabs']),
    },
    methods: {
        ...mapMutations('planEdit', ['setDisabledTabs']),
    },
})
export default class PlanEditTabs extends Vue {
    private tabIndex = -1;
    private tabKey: string = '';

    public hasResult!: boolean;
    public planEdit!: PlanEditModel | null;
    public disabledTabs!: boolean;
    public setDisabledTabs!: Function;

    get tabs() {
        return [
            {
                text: this.$t('Documents.PlanInput.Settings'),
                path: `/planedit/${this.planEdit?.Id}/settings`,
                key: `planEditSettings`,
            },
            {
                text: this.$t('Documents.PlanInput.ShiftSettings'),
                path: `/planedit/${this.planEdit?.Id}/shift`,
                key: `shift`,
            },
            {
                text: this.$t('Catalogues.Equipments.Equipment.NameSingle'),
                path: `/planedit/${this.planEdit?.Id}/equipment`,
                key: `planEditEquipment`,
            },
            {
                text: this.$t('Catalogues.Warehouses.WarehouseVeneer.NameMultiple'),
                path: `/planedit/${this.planEdit?.Id}/warehouseveneer`,
                key: `planEditWarehouseVeneer`,
            },
            {
                text: this.$t('Catalogues.Warehouses.WarehousePlywood.NameMultiple'),
                path: `/planedit/${this.planEdit?.Id}/warehouseplywood`,
                key: `planEditWarehousePlywood`,
            },
            {
                text: this.$t('Documents.PlanInput.Orders'),
                path: `/planedit/${this.planEdit?.Id}/plywoodorder`,
                key: `planEditPlywoodOrder`,
            },
            {
                text: this.$t('Documents.PlanRes.NameMultiple'),
                path: `/planedit/${this.planEdit?.Id}/result`,
                key: `planEditResult`,
                disabled: !this.hasResult,
            },
        ];
    }

    @Watch('planEdit', {immediate: true})
    onPlanEditChange() {
        this.getActualTab();
    }

    @Watch('hasResult')
    onHasResultChange(value: boolean, oldValue: boolean) {
        if (!oldValue && value) {
            this.tabIndex = 6;
            this.$router.replace(this.tabs[this.tabIndex].path).catch(() => {});
        }
    }

    onTabClick(tab: Tab, index: number) {
        if (this.tabIndex === index) return;
        this.$router
            .replace(tab.path)
            .then(() => {
                this.tabIndex = index;
                this.tabKey = tab.key;
            })
            .catch(() => {});
    }
    getActualTab() {
        let index = this.tabs.findIndex(item => this.$route.path.includes(item.path));
        if ((index === 6 && !this.hasResult) || (index === -1 && !this.hasResult)) {
            this.tabIndex = 0;
            this.$router.replace(this.tabs[this.tabIndex].path).catch(() => {});
        } else if (index === -1 && this.hasResult) {
            this.tabIndex = 6;
            this.$router.replace(this.tabs[this.tabIndex].path).catch(() => {});
        } else {
            this.tabIndex = index;
        }
        this.tabKey = this.tabs[this.tabIndex].key;
    }

    onListEdit() {
        (this.$refs.editDialog as any).open();
    }

    onTabEdit(bool: boolean) {
        this.setDisabledTabs(bool);
    }
}
